import type { BoxProps } from '@hover/blueprint';
import { Box } from '@hover/blueprint';
import type { ReactNode } from 'react';
import React from 'react';

interface MainProps extends BoxProps {
  children: ReactNode;
}

export const MIN_WIDTH = '21rem';
export const MAX_WIDTH = '24rem';

const Main = ({ children, ...props }: MainProps) => (
  <Box
    display="grid"
    maxWidth={MAX_WIDTH}
    minWidth={{ base: '100%', mobile: MIN_WIDTH }}
    {...props}
  >
    {children}
  </Box>
);

export { Main };
